export default __webpack_public_path__ + "static/media/close_filter.282d79a9.svg";